var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockTopLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 63,
    viewBox: "0 0 94 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1121 36.4924V27.7529H61.3477V36.4924H70.1121Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5262 45.2336V36.4941H8.76172V45.2336H17.5262Z",
    fill: "#FCE784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76059 36.4944V27.7549H-0.00390625V36.4944H8.76059Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1121 45.2336V36.4941H61.3477V45.2336H70.1121Z",
    fill: "#FCE784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0536 53.9729V45.2334H26.2891V53.9729H35.0536Z",
    fill: "#FBE683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76449 18.7395V10H0V18.7395H8.76449Z",
    fill: "#FBE683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0536 62.7121V53.9727H26.2891V62.7121H35.0536Z",
    fill: "#95C8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6395 53.9729V45.2334H78.875V53.9729H87.6395Z",
    fill: "#FDF2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0536 45.2336V36.4941H26.2891V45.2336H35.0536Z",
    fill: "#95C8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0536 36.4924V27.7529H26.2891V36.4924H35.0536Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5262 27.7531V19.0137H8.76172V27.7531H17.5262Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6395 36.4924V27.7529H78.875V36.4924H87.6395Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5848 53.9729V45.2334H43.8203V53.9729H52.5848Z",
    fill: "#486D97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5848 62.7121V53.9727H43.8203V62.7121H52.5848Z",
    fill: "#486D97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5848 36.4924V27.7529H43.8203V36.4924H52.5848Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76059 53.9729V45.2334H-0.00390625V53.9729H8.76059Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5262 62.7121V53.9727H8.76172V62.7121H17.5262Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3465 53.9729V45.2334H52.582V53.9729H61.3465Z",
    fill: "#228696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3465 62.7121V53.9727H52.582V62.7121H61.3465Z",
    fill: "#228696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3465 45.2336V36.4941H52.582V45.2336H61.3465Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8778 45.2336V36.4941H70.1133V45.2336H78.8778Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 53.9729V45.2334H17.5234V53.9729H26.2879Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 62.7121V53.9727H17.5234V62.7121H26.2879Z",
    fill: "#DDA4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 45.2336V36.4941H17.5234V45.2336H26.2879Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2879 14.1028V5.36328H17.5234V14.1028H26.2879Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8778 53.9729V45.2334H70.1133V53.9729H78.8778Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8778 62.7121V53.9727H70.1133V62.7121H78.8778Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8192 53.9729V45.2334H35.0547V53.9729H43.8192Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8192 62.7121V53.9727H35.0547V62.7121H43.8192Z",
    fill: "#218595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4051 53.9729V45.2334H87.6406V53.9729H96.4051Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8192 45.2336V36.4941H35.0547V45.2336H43.8192Z",
    fill: "#F5D858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8192 27.7551V19.0156H35.0547V27.7551H43.8192Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76059 45.2336V36.4941H-0.00390625V45.2336H8.76059Z",
    fill: "#8DA9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7645 18.7395V10H79V18.7395H87.7645Z",
    fill: "#8DA9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 63,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockTopLeft);
export default __webpack_public_path__ + "static/media/block-top-left.fb33fd4a2b8706f8159bb2081bdc025e.svg";
export { ForwardRef as ReactComponent };